module.exports = __webpack_public_path__ + "img/classify_img5.83fc919c.png";